export default __webpack_public_path__ + "static/media/logo1.c25d37f4.jpeg";